import { EnumIdType } from '@/typings'

export enum EnumWxMpPermissionMenuType {
  /** 角色层 */
  ROLE_LEVEL = 1,
  /** 分组层 */
  GROUP_LEVEL = 2,
  /** 菜单项 */
  MENU_ITEM = 3,
}

// 首页使用的menu类型
export type MenuOptionList = {
  label: string
  value: EnumIdType
  options: Array<{
    label: string
    options: Array<MenuOptionItemObj>
  }>
}[]

export interface MenuOptionItemObj {
  title: string
  iconUrl: string
  path: string
  badgeNum?: number
  isDotBadge?: boolean
}

// 微信小程序菜单列表=======================================》
export type WxMpPermissionMenuInfo = WxMpPermissionMenuItemInfo | WxMpPermissionMenuGroupInfo | WxMpPermissionMenuRoleInfo

// 角色身份层
export interface WxMpPermissionMenuRoleInfo {
  enabled: boolean
  id: string
  name: string
  parentId: string
  sortOrder: number
  roleCode: EnumIdType
  type: EnumWxMpPermissionMenuType.ROLE_LEVEL
  /**
   * @example  "2026-01-28T06:47:26.151344Z"
   */
  createdAt: string
  updatedAt: string
}

// 分组层
export interface WxMpPermissionMenuGroupInfo {
  enabled: boolean
  id: string
  name: string
  parentId: string
  sortOrder: number
  type: EnumWxMpPermissionMenuType.GROUP_LEVEL
  /**
   * @example  "2026-01-28T06:47:26.151344Z"
   */
  createdAt: string
  updatedAt: string
}

// 菜单menu
export interface WxMpPermissionMenuItemInfo {
  id: string
  /**
   * 父级id
   */
  parentId: string
  type: EnumWxMpPermissionMenuType.MENU_ITEM
  /**
   * 名称
   */
  name: string
  /**
   * 图标url
   */
  iconUrl: string
  /**
   * 小程序路径
   */
  path: string
  /**
   * 权限码
   */
  roleCode: EnumIdType
  /**
   * 俱乐部id
   */
  clubId: string
  /**
   * 排序
   */
  sortOrder: number
  /**
   * 显示/隐藏
   */
  enabled: boolean
  /**
   * 操作人id
   */
  operatorId: string
  createdAt: string
  /**
   * 更新时间
   * @example '2026-01-29T07:12:36.558Z'
   */
  updatedAt: string
}
